import { Component } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd, Scroll } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from './services/api.service';
import { TitleService } from './services/title.service';
import { environment } from '../environments/environment';
import { HistoryService } from './services/history.service';

declare let gtag: Function;
@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor(
    private apiService: ApiService,
    private titleService: TitleService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private historyService: HistoryService,
    private viewportScroller: ViewportScroller,
  ) {
    if (environment.production) {
      /** Google Analytics **/
      const script2 = document.createElement('script');
      script2.async = true;
      script2.type = 'text/javascript';
      script2.innerHTML = `window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }`;
      document.head.prepend(script2);
      const script1 = document.createElement('script');
      script1.async = true;
      script1.type = 'text/javascript';
      const gaLink = 'https://www.googletagmanager.com/gtag/js?id=' + environment.ga_code;
      script1.src = gaLink;
      document.head.prepend(script1);
    }

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((route: any) => {
      if (environment.production) {
        gtag('js', new Date());
        gtag('config', environment.ga_code);
        gtag('event', 'page_view', {
          page_title: this.titleService.getTitle(),
          page_path: route.urlAfterRedirects,
          page_location: this.router.url,
        });
      }

      /** global header **/
      if (document.getElementsByClassName('header')[0] != undefined && !document.getElementById('globalTHbanner')) {
        const script3 = document.createElement('script');
        script3.src = `${this.apiService.apiUrl}/config/global/js`;
        document.head.append(document.createComment(` Termhub Banner JS `));
        document.head.append(script3);

        const script4 = document.createElement('include-html');
        script4.id = 'globalTHbanner';
        document.body.prepend(script4);
        document.body.prepend(document.createComment(` Termhub Banner HTML `));
        const srcUrl = document.createAttribute('src');
        srcUrl.value = `${this.apiService.apiUrl}/config/global/html`;
        document.getElementById('globalTHbanner').setAttributeNode(srcUrl);

        const script5 = document.createElement('script');
        script5.type = 'text/javascript';
        script5.innerHTML = 'setInterval(() => window.globalTHbanner?.refresh(), 30000)';
        document.body.append(document.createComment(` Termhub Banner Refresh `));
        document.body.append(script5);
      }
    });

    /** scroll restoration: routes with data.manualScroll handle their own scrolling **/
    this.router.events.pipe(filter((event) => event instanceof Scroll)).subscribe((event: Scroll) => {
      let snapshot = this.router.routerState.snapshot.root;
      while (snapshot.firstChild) {
        snapshot = snapshot.firstChild;
      }
      if (snapshot.data?.['manualScroll']) {
        return;
      }
      if (event.position) {
        this.viewportScroller.scrollToPosition(event.position);
      } else {
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    });

    this.historyService.track();
  }
}
